export const DEMO_CALL_SECTIONS = ["analysis", "coaching", "notes", "transcript"];

export function canonicalDemoSection(value) {
  return DEMO_CALL_SECTIONS.includes(value) ? value : "analysis";
}

export function demoSectionPath(useCase, section) {
  const slug = useCase === "sales" ? "sales" : "renewals";
  return `/demo/${slug}?section=${canonicalDemoSection(section)}`;
}

export function shouldUseReducedMobileStory({ enabled, demoMode, isMobile, section }) {
  return Boolean(enabled && demoMode && isMobile && !DEMO_CALL_SECTIONS.includes(section));
}
